/**
 * <bp-nav-hamburger> — mobile navigation toggle.
 *
 * Toggles the `.is-open` class on the sibling .bp-nav-items list (or a
 * target specified via `data-target="#id"`). Matches the responsive
 * breakpoint in chrome.css where .bp-nav-items collapses into a dropdown.
 */

export class BpNavHamburger extends HTMLElement {
  private button: HTMLButtonElement | null = null;
  private target: HTMLElement | null = null;

  connectedCallback() {
    this.button = this.querySelector('button') ?? (this as unknown as HTMLButtonElement);
    const targetSelector = this.dataset.target ?? '.bp-nav-items';
    this.target = document.querySelector<HTMLElement>(targetSelector);

    this.button?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  private onClick = () => {
    if (!this.button || !this.target) return;
    const open = !this.target.classList.contains('is-open');
    this.target.classList.toggle('is-open', open);
    this.button.setAttribute('aria-expanded', open ? 'true' : 'false');
  };
}

if (!customElements.get('bp-nav-hamburger')) {
  customElements.define('bp-nav-hamburger', BpNavHamburger);
}
